import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY, DEFAULTS } from "common/config";
import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  CONFIRMS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { ApiReports } from "apihandlers//reports";
import { ApiMasters } from "apihandlers//masters/masters";
const ApiReportsHandler = new ApiReports();
const ApiMastersHandler = new ApiMasters();

const DriverLedger = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState<any>({});
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [exportName, setExportName] = useState("");
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "indentNo",
      name: LABELS.INDENT_NO,
      width: "10%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "fromLoc",
      name: LABELS.LOADING_POINTS,
      width: "10%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "toLoc",
      name: LABELS.UNLOADING_POINTS,
      width: "10%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "truckType",
      name: LABELS.VEHICLE_TYPE,
      width: "10%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "vehicleNo",
      name: LABELS.VEHICLE_NO,
      width: "10%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "driverUsername",
      name: LABELS.DRIVER_NAME,
      width: "10%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "dieselAmt",
      name: LABELS.DIESEL,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "advanceAmt",
      name: LABELS.ADVANCE,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "odoOpen",
      name: LABELS.OPENING_KM,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "odoClose",
      name: LABELS.CLOSING_KM,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "totalKm",
      name: LABELS.RUNNING_KM,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "tollAmt",
      name: LABELS.TOLL,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "rtoAmt",
      name: LABELS.RTO,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "policeAmt",
      name: LABELS.POLICE,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "bataAmt",
      name: LABELS.DRIVER_BATA,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "loadingAmt",
      name: LABELS.LOADING_EXPENSE,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "unloadingAmt",
      name: LABELS.UNLOADING_EXPENSE,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "weightmentAmt",
      name: LABELS.WEIGHTMENT_EXPENSE,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "totalExpenseAmt",
      name: LABELS.TOTAL_EXPENSE,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "claimAmt",
      name: LABELS.CLAIM,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "tripBalance",
      name: LABELS.OUTSTANDING,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
  ];

  useEffect(() => {
    if (loading) {
      getMasterData();
    }
  }, [loading]);

  const getMasterData = () => {
    const args = { shortMode: true };
    ApiMastersHandler.getDrivers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [{ id: -1, label: "All" }];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].id,
            label: recs[i].fullName,
          });
        }
        setMasters(list);
        setLoading(false);
      }
    });
  };

  const loadChart = () => {
    const id = masterRef.current.selectedValue.id;
    if (!id) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.DATA_IS_EMPTY);
      return;
    }
    const driver = masterRef.current.selectedValue.label;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    setExportName(
      LABELS.DRIVER +
        ": " +
        driver +
        "\n" +
        LABELS.FROM_DATE +
        ": " +
        fromDt +
        "\n" +
        LABELS.TO_DATE +
        ": " +
        toDt
    );
    const args = {
      fromDt,
      toDt,
      // id: -1,
      // vehicleId: -1,
      driverId: id,
      reportType: "excel",
    };
    let errors = [];
    if (fromDt == "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt == "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    setChartData(null);
    setRows(null);
    ApiReportsHandler.getDriverLedgerSummary(args).then((res) => {
      // console.log("getUserLogReport:", args);
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
        }
        setChartData(response);
        setRows(response.rows);
      }
    });
  };

  const masterRef: any = useRef();

  // console.log("elist:", masters);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.DRIVER_LEDGER_REPORT}</li>
        </ul>
        <h4>{TITLES.DRIVER_LEDGER_REPORT}</h4>
        <p className="SubTitles">{SUB_TITLES.DRIVER_LEDGER_REPORT}</p>
      </div>
      {loading ? (
        <div className="flexCenter" style={{ minHeight: 450 }}>
          <Loader />
        </div>
      ) : (
        <div className="hChart">
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 5,
                marginBottom: 10,
                width: "40%",
              }}
            >
              <label>{"Select Driver :"}</label>
              <AutoComplete
                id={"masters"}
                list={masters}
                childRef={masterRef}
                defaultValue={{ id: -1, label: "All" }}
              />
            </div>
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 0,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.TO_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                }}
              >
                <Btn text={LABELS.LOAD} onClick={loadChart} />
              </div>
            </div>
          </div>
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {rows && (
            <ExcelGrid
              id={"driverLedgerReport"}
              title={LABELS.DRIVER_LEDGER_REPORT}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={exportName}
              // onReload={reloadGrid}
              // onAdd={onAdd}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(DriverLedger);
